export const getNumberByPx = (px: string | null) => parseFloat(px ? px.replace('px', '') : '0px')
